import {
  ColorScheme,
  Scale,
  DARK_CLASS,
  INVERT_CLASS, // legacy compatibility class
  LIGHT_CLASS,
  COLORSCHEME_DEPENDENT_CLASS,
  SCALE_SM_CLASS,
  SCALE_MD_CLASS,
  SCALE_LG_CLASS,
  SCALE_DEPENDENT_CLASS
} from '../../../UNSAFE_Theme';

export type ThemeProps = {
  colorScheme?: ColorScheme;
  scale?: Scale;
};

const DARK_CLASSES = `${DARK_CLASS} ${INVERT_CLASS}`;

const themeInterpolations = {
  colorScheme: ({ colorScheme }: Pick<ThemeProps, 'colorScheme'>) =>
    colorScheme === undefined
      ? {}
      : {
          class: `${
            colorScheme === 'dark' ? DARK_CLASSES : LIGHT_CLASS
          } ${COLORSCHEME_DEPENDENT_CLASS}`
        },
  scale: ({ scale }: Pick<ThemeProps, 'scale'>) =>
    scale === undefined
      ? {}
      : {
          class: `${
            scale === 'sm' ? SCALE_SM_CLASS : scale === 'md' ? SCALE_MD_CLASS : SCALE_LG_CLASS
          } ${SCALE_DEPENDENT_CLASS}`
        }
};

export { themeInterpolations };
